import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLabsSettingsPage = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLabsSettingsPage);
};
